// /**
//  * Orders details - list
//  */

// React
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

// UI
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Grid,
  Button,
  Dialog,
  DialogContent,
  Box,
  MenuItem,
  Menu,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiChevronDown,
  mdiChevronUp,
  mdiClose,
} from '@mdi/js';

// Helper
import {
  translate,
  checkMatchMedia,
  removeEmptyValueObject,
} from '../../../utils/helpers';

// Type
import { Item } from '../interfaces';
import theme from '../../../theme';
import { Typography } from '@material-ui/core';
import warehouseUnitRepository from 'client-sdk/src/Repository/warehouse-unit-repository';
import handleError from '../../../utils/handleError';
import { operatorAssigmentItemIssue } from '../../../api/operator/post';
import handleNotfication from '../../../utils/handleNotification';
// style
import styles from './listPickMob.module.scss'
type Data = Item;
type Unit = {
  variantId: number;
  unitCode: string;
}
type Props = {
  setOpenUnits: (orderItem: Item) => void;
  locateItem: (inventoryItem: any) => void;
  data: any;
  units: { [key: number]: Unit }
};
type Ord = 'asc' | 'desc';
interface HeadCell {
  id: keyof Data;
  label: string;
}
interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      whiteSpace: 'nowrap',
      color: theme.palette.common.white,
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      whiteSpace: 'nowrap',
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(even)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiTableCell-root': {
        padding: '5px',
      }
    },
    paper: {
      width: '100%',
    },
    parentRow: {
      '& > td': {
        fontWeight: 500,
        fontSize: '15px',
      }
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    textArea: {
      width: '100%',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 540,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
  })
);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const classes = useStyles();
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property: keyof Data) => (
    event: React.MouseEvent<unknown>
  ) => {
    onRequestSort(event, property);
  };
  const headCells: HeadCell[] = [
    { id: 'status', label: 'وضعیت' },
    { id: 'productName', label: 'نام کالا' },
    { id: 'productId', label: 'شناسه کالا' },
    { id: 'variantId', label: 'شناسه تنوع کالا' },
    { id: 'productCode', label: 'کد کالا' },
    { id: 'variantCode', label: 'کد تنوع کالا' },
    { id: 'count', label: 'تعداد' },
    { id: 'serialNumber', label: 'سریال کالا' },
  ];

  return (
    <TableHead>
      <StyledTableRow>
        <StyledTableCell />
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              classes={{
                // Override with the active class if this is the selected column or inactive otherwise
                icon:
                  orderBy === headCell.id
                    ? classes.activeSortIcon
                    : classes.inactiveSortIcon,
              }}
              IconComponent={() => (
                <Icon
                  path={
                    orderBy === headCell.id && order === 'desc'
                      ? mdiChevronDown
                      : mdiChevronUp
                  }
                  size={0.7}
                  className={
                    orderBy === headCell.id
                      ? classes.activeSortIcon
                      : classes.inactiveSortIcon
                  }
                />
              )}
            >
              {headCell.label}
            </TableSortLabel>
          </StyledTableCell>
        ))}
        <StyledTableCell />
      </StyledTableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState<Ord>('asc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('status');

  return (
    <div className={classes.root}>
      <TableContainer className={classes.container}>
        <Table
          stickyHeader
          className={classes.table}
          aria-labelledby="tableTitle"
          size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
          aria-label="enhanced table"
        >

          <TableBody>
            {stableSort(props.data, getComparator(order, orderBy))
              .slice()
              .map((row: any, index: number) => {
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <>

                    <Row
                      key={index}
                      row={row}
                      units={props.units}
                      index={index}
                      labelId={labelId}
                      setOpenUnits={() => props.setOpenUnits(row)}
                      locateItem={props.locateItem}
                    />
                  </>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

    </div>
  );
}

function Row(props: {
  row: any;
  labelId: string;
  index: number;
  setOpenUnits: () => void;
  locateItem: (inventoryItem: any) => void;
  units: any
}) {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const { row, labelId, index, setOpenUnits } = props;
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const [damaigItemDiolog, openDamaigItemDiolog] = useState(false)
  let variantName =
    row.type === 'PRODUCT' ? row.productName : translate(row.type, 'inventory');
  for (let i = 0; i <= 2 && row.featureAndValues[i]; i++) {
    variantName = variantName.concat(
      ' - ',
      row.featureAndValues[i].key,
      ' : ',
      row.featureAndValues[i].value
    );
  }

  if (row.sellerName || row.providerName) {
    const sellerName = row.sellerName ?? row.providerName;
    variantName = variantName.concat(' ( ', sellerName, ' )');
  }
  const handleBrokenItem = (item) => {
    openDamaigItemDiolog(true)
  }
  const handleBrokenItemAction = async () => {
    try {
      await operatorAssigmentItemIssue(row.id)
      handleNotfication('سفارش از لیست شما حذف شد', 'success')
      openDamaigItemDiolog(false)
      setTimeout(() => {

        history.goBack()
      }, 100);

    } catch (error) {
      handleNotfication('سفارشی یافت نشد', 'error')
    }
  }


  return (
    <>

      <StyledTableRow className={classes.parentRow} key={index} tabIndex={-1}>
        
        <TableCell align="center" style={{ justifyContent: 'center', minWidth: '60px' }}>
          <Typography style={{ color: row.amount === row.inventoryItems.length ? '#329926' : '#ff4d1f' }}>
            {row.amount} / {row.inventoryItems.length}
          </Typography>
        </TableCell>
        <TableCell align="left" data-cy="row-id">
          <p>
            <Typography style={{ color: 'rgba(0, 0, 0, 0.8)' }}>
              {variantName}
            </Typography>
          </p>
          <p>
            <Typography style={{ color: '#000000', fontWeight: 500 }}>
              شناسه تنوع:{row.variantId}
            </Typography>
          </p>
          <p>
            <Typography style={{ color: "#828282" }}>
              یونیت:
            </Typography>
            <Grid container justifyContent='space-between'>
              {props?.units[row.variantId] && props?.units[row.variantId].map(unit => (
                <Grid item lg={4}>
                  <span style={{ color: "#828282", marginLeft: "10px" }}>{unit.unitCode}</span>
                </Grid>
              ))}
            </Grid>
          </p>
        
        </TableCell>
        <TableCell align="right" style={{margin:0, display:"flex"}} >
          <div className={styles.settingCotainer}>

       
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            disabled={row.inventoryItems.length === 0}
          >
            {open ? (
              <Icon
                path={mdiChevronUp}
                size={1}
                color={
                  '#000000'
                }
              />
            ) : (
              <Icon
                path={mdiChevronDown}
                size={1}
                color={
                  row.inventoryItems.length === 0 ? 'gray' : '#000000'
                }
              />
            )}
          </IconButton>
          </div>
        </TableCell>
        
      </StyledTableRow>
      {
        open
          ? row.inventoryItems.map((inventoryItem: any) => {
            return (
              <StyledTableRow>
                <TableCell>

                </TableCell>

                <TableCell scope="row" align="left">

                  <p>
                    <Typography style={{ color: '#000000' }}>

                      سریال: {inventoryItem.serialNumber}
                    </Typography>
                  </p>
                </TableCell>

                <TableCell align="right">
                  <IconButton
                    aria-label="locate"
                    size="small"
                    title="جایگذاری آیتم"
                    data-cy="locate"
                    onClick={() => props.locateItem(inventoryItem)}
                  >
                    <Icon
                      path={mdiClose}
                      color={theme.palette.error.main}
                      size={1}
                    />
                  </IconButton>
                </TableCell>
              </StyledTableRow>
            );
          })
          : null
      }
    </>
  );
}
